import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getConfirmacionStatusService,
  getCurrentConfirmacionService,
  sendConfirmacionAnswerService,
  getMisTalentosService,
  getConfirmacionesCompletadasService,
  getConfirmacionSummaryService,
} from "../../services/confirmacion/confirmacion.service";

export const getConfirmacionStatusThunk = createAsyncThunk(
  "confirmacion/getStatus",
  async (_, { rejectWithValue }) => {
    try {
      return await getConfirmacionStatusService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el estado de confirmación"
      );
    }
  }
);

export const getCurrentConfirmacionThunk = createAsyncThunk(
  "confirmacion/getCurrent",
  async (_, { rejectWithValue }) => {
    try {
      return await getCurrentConfirmacionService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener la pregunta actual"
      );
    }
  }
);

export const sendConfirmacionAnswerThunk = createAsyncThunk(
  "confirmacion/sendAnswer",
  async (payload, { rejectWithValue }) => {
    try {
      return await sendConfirmacionAnswerService(payload);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al enviar la respuesta"
      );
    }
  }
);

export const getMisTalentosThunk = createAsyncThunk(
  "confirmacion/getMisTalentos",
  async (_, { rejectWithValue }) => {
    try {
      return await getMisTalentosService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener los talentos"
      );
    }
  }
);

export const getConfirmacionesCompletadasThunk = createAsyncThunk(
  "confirmacion/getCompletadas",
  async (_, { rejectWithValue }) => {
    try {
      return await getConfirmacionesCompletadasService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener las confirmaciones completadas"
      );
    }
  }
);

export const getConfirmacionSummaryThunk = createAsyncThunk(
  "confirmacion/getSummary",
  async (_, { rejectWithValue }) => {
    try {
      return await getConfirmacionSummaryService();
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error al obtener el resumen"
      );
    }
  }
);
